import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow.svg';
import { useLanguage } from '../../../Context/LanguageContext';

export default function SelectHoldingStateBox(props) {
  const {
    isClickedHoldingSorting,
    isClickedMaintainSorting,
    setIsClickedHoldingSorting,
    setIsClickedMaintainSorting
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target
      && !ButtonRef.current.contains(e.target)) {
        setIsClicked(false);
    }
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} onClick={() => setIsClicked(!isClicked)}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? `#FF8B48` : `#3E4148`} hover='pointer'>홀딩 여부</Text>
        {
          (!isClickedHoldingSorting && !isClickedMaintainSorting) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledArrow $isClicked={isClicked} />
          </ArrowWrapper>
        }
        {
          (isClickedHoldingSorting || isClickedMaintainSorting) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? `#FF8B48` : `#3E4148`} hover='pointer'>:</Text>
        }
        {
          isClickedHoldingSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? `#FF8B48` : `#3E4148`} hover='pointer'>{isClickedMaintainSorting ? `홀딩중,` : `홀딩중`}</Text>
        }
        {
          isClickedMaintainSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? `#FF8B48` : `#3E4148`} hover='pointer'>사용중</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} $isDark={isDark}>
        <Option onClick={() => setIsClickedHoldingSorting(!isClickedHoldingSorting)}>
          <CheckBox isClicked={isClickedHoldingSorting} />
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color='$595959' hover='pointer'>홀딩중</Text>
        </Option>
        <Option onClick={() => setIsClickedMaintainSorting(!isClickedMaintainSorting)}>
          <CheckBox isClicked={isClickedMaintainSorting} />
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color='$595959' hover='pointer'>사용중</Text>
        </Option>
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 4px;

  height: 20px;

  gap: 4px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 10px;
  height: 6px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(-180deg)` : `rotateZ(0deg)`};
`;

const StyledArrow = styled(DownArrowSvg)`
  width: 10px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.$isClicked ? props.theme.primary : props.theme.subText};

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 26px;

  width: 88px;
  height: ${props => props.isClicked ? `70px` : `0px`};

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 0px 0px 6px;

  width: calc(100% - 6px);
  height: 35px;

  gap: 6px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subText}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
